import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import $ from "jquery"; // Import jQuery
import BASE_URL from "../config"; // ✅ Import BASE_URL

const AddPage = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    pagename: "",
    slug: "",
    title: "",
    meta: "",
    content: "",
    category: "",
    parent_id: "",
    addedby: "",
    modifiedby: "",
    addedat: new Date().toISOString().split("T")[0],
    modifiedat: new Date().toISOString().split("T")[0],
    active: true,
  });

  // Fetch logged-in user data
  useEffect(() => {
    const token = localStorage.getItem("token");
    
    if (!token) {
      window.location.href = "/login";
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/user/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 403) {
          localStorage.removeItem("token");
          window.location.href = "/login";
          return;
        }

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUserData(data);

        // Update `addedby` and `modifiedby`
        setFormData((prev) => ({
          ...prev,
          addedby: data.id || "",
          modifiedby: data.id || "",
        }));

        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Fetch categories
  useEffect(() => {
    const fetchPages = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}api/pages/find-all`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data) {
          const filteredCategories = response.data.filter(
            (category) => !category.parent_id
          );
          setCategories(filteredCategories);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchPages();
  }, []);

  // Handle input change and remove error message on typing
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ 
      ...formData, 
      [name]: name === "parent_id" ? (value ? Number(value) : null) : value 
    });
    // Remove error message on typing
    $(e.target).next(".error-message").remove();
  };

// Handle form submission with jQuery validation
const handleSubmit = async (e) => {
  e.preventDefault();

  let isValid = true;
  $(".error-message").remove(); // Remove previous error messages

  // Custom error messages for each field
  const errorMessages = {
    pagename: "Page name is required.",
    slug: "Slug is required.",
    title: "Title is required.",
    content: "Content is required.",
    meta: "Meta description is required.",
    parent_id: "Parent selection is required.",
    category: "Category selection is required."
  };

  Object.keys(errorMessages).forEach((field) => {
    let inputField = $(`input[name=${field}], textarea[name=${field}], select[name=${field}]`); // Include select fields

    if (!inputField.val() || !inputField.val().trim()) {
      inputField.addClass("border border-danger"); // Apply red border
      inputField.after(`<div class="error-message text-danger">${errorMessages[field]}</div>`);
      isValid = false;
    } else {
      inputField.removeClass("border border-danger"); // Remove red border if corrected
    }
     // Remove error message and border on input
     inputField.on("input change", function () {
      $(this).removeClass("border border-danger");
      $(this).next(".error-message").remove();
    });
  
  });

  


    if (!isValid) {
      return;
    }

    try {
      const token = localStorage.getItem("token");

      await axios.post(`${BASE_URL}api/pages/create`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: "Page Created!",
        text: "The page has been successfully added.",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        navigate("/pages");
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.error || "Failed to add page.",
      });
      console.error("Error:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="text-primary">Add Page</h2>

      {loading ? (
        <p className="text-center">Loading...</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Page Name</label>
              <input
                type="text"
                name="pagename"
                className="form-control"
                value={formData.pagename}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Slug</label>
              <input
                type="text"
                name="slug"
                className="form-control"
                value={formData.slug}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Title</label>
              <input
                type="text"
                name="title"
                className="form-control"
                value={formData.title}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Category</label>
              <select
                name="category"
                className="form-control"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category.category} value={category.category}>
                    {category.category}
                  </option>
                ))}
              </select>
            </div> 
          </div>
          <div className="col-md-6">
              <label className="form-label">Parent </label>
              <select
                name="parent_id"
                className="form-control"
                value={formData.parent_id || ""}
                onChange={handleChange}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.pagename}
                  </option>
                ))}
              </select>
            </div> 
          <div className="mb-3">
            <label className="form-label">Content</label>
            <textarea
              name="content"
              className="form-control"
              rows="5"
              value={formData.content}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Meta Description</label>
              <textarea
                name="meta"
                className="form-control"
                rows="5"
                value={formData.meta}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          {/* Hidden input to store `addedby` */}
          <input type="hidden" name="addedby" value={formData.addedby} />

          <button type="submit" className="btn btn-primary me-1">
            Add Page
          </button>
          <a href="/pages" className="btn btn-secondary ms-1">
            Cancel
          </a>
        </form>
      )}
    </div>
  );
};

export default AddPage;
